module.exports = __webpack_public_path__ + "static/media/blue-add.6b2c4d66.svg";